import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    closeButtonAriaLabel: 'Remove invalid file',
    connectionError: {
      description:
        'We could not add your document. Please check your internet connection.',
      title: 'Connection error',
    },
    fileType: 'Incorrect format (JPG, PNG only)',
    maxSize: 'This file is too big (max {maxSize}MB)',
  },
  fr: {
    closeButtonAriaLabel: 'Supprimer le fichier invalide',
    connectionError: {
      description:
        'Nous n’avons pas pu ajouter votre document. Vérifiez votre connexion internet.',
      title: 'Erreur de connexion',
    },
    fileType: 'Format non valide (JPG ou PNG uniquement)',
    maxSize: 'Ce fichier est trop lourd (max {maxSize} Mo)',
  },
} as const);

export default locales;
